export default "__VITE_ASSET__Bbj$BiXg__"